import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { SurveyStatisticsData, SurveySeriesStatistics } from './types';
import { getSurveyStatistics, getSeriesStatistics } from './surveysApi';

interface SurveyStatisticsState {
  data: SurveyStatisticsData | null;
  seriesData: SurveySeriesStatistics | null;
  loading: boolean;
  seriesLoading: boolean;
  error: string | null;
  seriesError: string | null;
}

const initialState: SurveyStatisticsState = {
  data: null,
  seriesData: null,
  loading: false,
  seriesLoading: false,
  error: null,
  seriesError: null,
};

export const loadSurveyStatistics = createAsyncThunk(
  'surveyStatistics/load',
  async ({ surveyId, years }: { surveyId: string; years?: number }) => {
    return await getSurveyStatistics(surveyId, years);
  },
);

export const loadSeriesStatistics = createAsyncThunk(
  'surveyStatistics/loadSeries',
  async ({ seriesId }: { seriesId: string }) => {
    return await getSeriesStatistics(seriesId);
  },
);

const surveyStatisticsSlice = createSlice({
  name: 'surveyStatistics',
  initialState,
  reducers: {
    clearStatistics(state) {
      state.data = null;
      state.seriesData = null;
      state.error = null;
      state.seriesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadSurveyStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSurveyStatistics.fulfilled, (state, action: PayloadAction<SurveyStatisticsData>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loadSurveyStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Error al cargar estadísticas';
      })
      .addCase(loadSeriesStatistics.pending, (state) => {
        state.seriesLoading = true;
        state.seriesError = null;
      })
      .addCase(loadSeriesStatistics.fulfilled, (state, action: PayloadAction<SurveySeriesStatistics>) => {
        state.seriesLoading = false;
        state.seriesData = action.payload;
      })
      .addCase(loadSeriesStatistics.rejected, (state, action) => {
        state.seriesLoading = false;
        state.seriesError = action.error.message || 'Error al cargar serie';
      });
  },
});

export const { clearStatistics } = surveyStatisticsSlice.actions;
export default surveyStatisticsSlice.reducer;
